import React, { useRef } from "react";
import OmIcon from "./OmIcon";

// React wrapper for Om Design System Button web component
const OmButton = React.forwardRef(({ 
  children,
  onClick,
  type = "button",
  disabled = false,
  buttonType = "filled-button", // Default to filled-button
  buttonSize = "large", // Default to large
  ghostMode = false,
  leadingIcon,
  trailingIcon,
  iconSlot,
  ...props 
}, ref) => {
  const elementRef = useRef(null);

  const handleClick = (event) => {
    if (onClick && !disabled) {
      onClick(event);
    }
  };

  return (
    <omk-button
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      type={type}
      disabled={disabled}
      button-type={buttonType}
      button-size={buttonSize}
      ghost-mode={ghostMode}
      leading-icon={leadingIcon}
      trailing-icon={trailingIcon}
      onClick={handleClick}
      {...props}
    >
      {children}
      {iconSlot && (
        <OmIcon slot="icon">{iconSlot}</OmIcon>
      )}
    </omk-button>
  );
});

OmButton.displayName = 'OmButton';

export default OmButton;
